// extracted by mini-css-extract-plugin
export default {"message":"message__networkStateObserver__S5aUi"};